import { render, staticRenderFns } from "./IncomeExpenses.vue?vue&type=template&id=5099a8a7&scoped=true&"
import script from "./IncomeExpenses.vue?vue&type=script&lang=ts&"
export * from "./IncomeExpenses.vue?vue&type=script&lang=ts&"
import style0 from "./IncomeExpenses.vue?vue&type=style&index=0&id=5099a8a7&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5099a8a7",
  null
  
)

export default component.exports